module.exports = __webpack_public_path__ + "static/media/ev10.3b9254f7.jpg";